import '@/vendor/jquery.expander'

import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="jquery-expander"
export default class extends Controller {
  static values = {
    slicePoint: { type: Number, default: 250 }
  }

  connect() {
    $(this.element).expander({
      slicePoint: this.slicePointValue,
      preserveWords: true,
      widow: 4,
      expandText: 'Lire la suite',
      expandPrefix: '&hellip; ',
      expandEffect: 'show',
      userCollapse: true,
      userCollapseText: 'Replier',
      userCollapsePrefix: ''
    })
  }
}
